module.exports = {"440823100":"遂城镇","440823101":"黄略镇","440823102":"洋青镇","440823103":"界炮镇","440823104":"乐民镇","440823105":"江洪镇","440823106":"杨柑镇","440823107":"城月镇","440823108":"乌塘镇","440823109":"建新镇","440823110":"岭北镇","440823111":"北坡镇","440823112":"港门镇","440823113":"草潭镇","440823114":"河头镇","440823450":"广前公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440823.json
// module id = 1827
// module chunks = 0